import Choices from './choices.js';

const selectClassNames = {
  containerOuter: 'fil-choices',
  containerInner: 'fil-choices__inner',
  input: 'fil-choices__input',
  inputCloned: 'fil-choices__input--cloned',
  list: 'fil-choices__list',
  listItems: 'fil-choices__list--multiple',
  listSingle: 'fil-choices__list--single',
  listDropdown: 'fil-choices__list--dropdown',
  item: 'fil-choices__item',
  itemSelectable: 'fil-choices__item--selectable',
  itemDisabled: 'fil-choices__item--disabled',
  itemChoice: 'fil-choices__item--choice',
  groupParent: 'fil-choices__item--parent',
  placeholder: 'fil-choices__placeholder',
  group: 'fil-choices__group',
  groupHeading: 'fil-choices__heading',
  button: 'fil-choices__button',
};

export const selectMask = (element, options, isMultiple) => {
  var selectEle = element;
  const { shadowRoot } = options;
  if (shadowRoot) {
    selectEle = shadowRoot.querySelector('select');
  }
  // single select
  if (!isMultiple) {
    return new Choices(selectEle, {
      allowHTML: true,
      silent: true,
      placeholder: false,
      itemSelectText: '',
      shouldSort: false,
      renderSelectedChoices: 'always',
      searchEnabled: false,
      removeItems: true,
      classNames: selectClassNames,
      noResultsText: 'No result found',
      searchResultLimit: 50,

      callbackOnCreateTemplates(template) {
        return {
          choice: ({ classNames }, data) =>
            template(`<div class="${classNames.item} ${classNames.itemChoice} ${
              data.selected ? classNames.selectedState : ''
            } ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable}"
              data-select-text="${this.config.itemSelectText}"
              title='${data.customProperties}'
              data-choice
              ${
                data.disabled
                  ? 'data-choice-disabled aria-disabled="true"'
                  : 'data-choice-selectable'
              }
              data-id="${data.id}"
              data-value="${data.value}"
              role="option"
              aria-role="option"
              aria-selected="${data.selected ? 'true' : 'false'}">
              ${data.label}
            </div>`),
        };
      },
      ...options,
    });
  }

  return new Choices(selectEle, {
    allowHTML: true,
    silent: true,
    placeholder: false,
    itemSelectText: '',
    shouldSort: false,
    renderSelectedChoices: 'always',
    renderItems: true,
    searchEnabled: false,
    removeItems: true,
    removeItemButton: true,
    renderChoiceLimit: 0,
    resetScrollPosition: false,
    classNames: selectClassNames,
    right: options.right,
    size: options.size,
    callbackOnCreateTemplates(template) {
      return {
        item: ({ classNames }, data) =>
          template(`<div style="display: none;"
          class="${classNames.item} ${
            data.highlighted ? classNames.highlightedState : classNames.itemSelectable
          } ${data.placeholder ? classNames.placeholder : ''}"
          data-id="${data.id}"
          data-value="${data.value}"
          role="option"
          aria-role="option"
          ${data.active ? 'aria-selected="true"' : ''}
          ${data.disabled ? 'aria-disabled="true"' : ''}>${data.value}</div>`),
        choice: ({ classNames, right, size }, data) => {
          return template(`<div id="${`${classNames.item}--multiple`}"
          class="${classNames.item} ${classNames.itemChoice} ${
            data.selected ? classNames.selectedState : ''
          }
          ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable}"
          data-select-text="${this.config.itemSelectText}"
          data-choice
          ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'}
          data-id="${data.id}"
          data-value="${data.value}"
          title='${data.customProperties}'
          role="option"
          aria-role="option"
          aria-selected="${data.selected ? 'true' : 'false'}">
          <fil-checkbox value="${data.value}" ${data.selected ? 'checked' : null} ${right ? 'right' : null} ${size === 'small' ? 'size="small"' : null} ${data.disabled ? 'disabled' : null} truncate>${data.label}</fil-checkbox>
          </div>`);
        },
      };
    },
    ...options,
  });
};
